"use client";

import { Instagram, MapPin, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ShowerTheOhlsons() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const tickerItems = ["BABY OHLSON", "EST. 2024", "MIST WHITE", "WILLOW SAGE", "BABY OHLSON", "EST. 2024", "MIST WHITE", "WILLOW SAGE"];
  const contactLinks = [{
    label: "Follow Our Journey",
    icon: Instagram,
    to: "https://instagram.com",
    newTab: true
  }, {
    label: "The Venue Location",
    icon: MapPin,
    to: "/EventDetailsPage",
    newTab: false
  }, {
    label: "Gift Registry Access",
    icon: Mail,
    to: "#",
    newTab: false
  }];
  return <section data-section-id="1847" id="shower-the-ohlsons" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32" style={{
    backgroundColor: "hsl(145 20% 8%)",
    color: "hsl(120 15% 95%)"
  }}>
      {}
      <div className="absolute top-0 left-0 right-0 overflow-hidden border-b border-[hsl(135_20%_85%/0.15)] py-3">
        <div className="flex whitespace-nowrap" style={{
        animation: "marqueeLetsCollab 38s linear infinite",
        fontFamily: "var(--font-mono)"
      }}>
          {[...tickerItems, ...tickerItems].map((item, i) => <span key={i} data-index={i} className="mx-6 inline-flex items-center text-xs tracking-[0.2em] uppercase" style={{
          color: "hsl(135 25% 65%)"
        }}>
              <span className="mr-6" aria-hidden="true">
                
              </span>
              {item}
            </span>)}
        </div>
      </div>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -top-10 -left-16 h-72 w-72 opacity-[0.12] md:h-96 md:w-96" viewBox="0 0 200 200" fill="none" style={{
      color: "hsl(135 25% 65%)"
    }}>
        <path d="M20 180 C 40 120, 80 80, 160 30 M50 170 C 70 130, 100 110, 150 80 M70 160 C 90 130, 110 120, 145 110 M40 175 C 60 150, 90 140, 130 135" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
        <path d="M30 175 L160 35 M55 168 L150 78 M75 158 L145 108" stroke="currentColor" strokeWidth="0.5" strokeLinecap="round" />
      </svg>

      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-32 -right-20 h-[240px] w-[240px] md:h-[420px] md:w-[420px] hidden md:block" style={{
      backgroundColor: "hsl(135 25% 65%)",
      borderTopLeftRadius: "0px",
      borderTopRightRadius: "0px",
      borderBottomLeftRadius: "0px",
      borderBottomRightRadius: "0px",
      clipPath: "inset(0 0 50% 0)",
      transform: "translate(20%, 50%)",
      opacity: 0.1
    }} />
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-28 left-1/2 -translate-x-1/2 h-[240px] w-[240px] md:hidden" style={{
      backgroundColor: "hsl(135 25% 65%)",
      borderRadius: "0px",
      clipPath: "inset(0 0 50% 0)",
      opacity: 0.1
    }} />

      <div ref={ref} className="relative z-10 mx-auto max-w-[1360px] px-6 md:px-10 lg:px-16 pt-10">
        {}
        <div className={`mb-10 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        fontFamily: "var(--font-mono)"
      }}>
          <span className="inline-flex items-center gap-2 text-xs md:text-sm tracking-[0.2em] uppercase" style={{
          color: "hsl(120 15% 95%)"
        }}><span data-ast-id="f:/src/pages/Home/sections/ShowerTheOhlsons.tsx|sig:h4xhod" data-ast-start="4123" data-ast-end="4174" style={{
            color: 'rgb(143, 188, 155)'
          }}></span>ARCHIVE 2026 — SHOWER THE OHLSONS</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {}
          <div className="lg:col-span-8">
            <h2 className={`font-default font-normal leading-[1.1] tracking-tight transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(2.5rem, 6.2vw, 5rem)",
            color: "hsl(120 15% 95%)",
            fontFamily: "var(--font-serif)"
          }}>
              Celebrate the{" "}
              <span className="relative inline-block">
                <em className="italic font-normal" style={{
                color: "hsl(135 25% 65%)"
              }}>
                  newest
                </em>
                <svg aria-hidden="true" viewBox="0 0 240 14" className="absolute left-0 -bottom-1 w-full h-3" preserveAspectRatio="none">
                  <path d="M2 9 C 30 3, 60 12, 90 6 S 150 11, 180 5 S 230 10, 238 7" stroke="hsl(135 25% 65%)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                </svg>
              </span>{" "}
              chapter with us.
            </h2>

            <p className={`mt-8 max-w-2xl transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
            lineHeight: 1.6,
            color: "hsl(120 15% 95% / 0.8)",
            fontFamily: "var(--font-sans)"
          }}>
              Join us for a morning of soft light, organic textures, and shared 
              joy as we prepare to welcome Baby Ohlson. A curated brunch menu 
              and maternity gallery await your presence in our garden archive.
            </p>

            <div className={`mt-10 flex items-center gap-4 transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontFamily: "var(--font-mono)"
          }}>
              <div className="h-px flex-1 max-w-[120px]" style={{
              backgroundColor: "hsl(135 20% 85% / 0.3)"
            }} />
              <span className="text-xs tracking-[0.2em] uppercase" style={{
              color: "hsl(120 15% 95% / 0.6)"
            }}>
                The Ohlson Residence · 2024
              </span>
              <span style={{
              color: "hsl(135 25% 65%)"
            }}></span>
            </div>
          </div>

          {}
          <div className="lg:col-span-4 flex flex-col gap-4">
            {contactLinks.map((link, i) => {
            const Icon = link.icon;
            return <Link key={i} data-index={i} to={link.to} newTab={link.newTab} className={`group block transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: `${300 + i * 90}ms`
            }}>
                  <Button variant="outline" className="w-full justify-start gap-4 rounded-md border-[1px] bg-transparent px-6 py-7 h-auto text-base transition-all duration-250 hover:bg-white/5" style={{
                borderColor: "hsl(135 20% 85% / 0.4)",
                color: "hsl(120 15% 95%)",
                fontFamily: "var(--font-sans)",
                fontWeight: 500
              }}>
                    <span className="inline-flex h-9 w-9 items-center justify-center rounded-md shrink-0 transition-colors duration-250" style={{
                  backgroundColor: "hsl(135 25% 65% / 0.1)"
                }}>
                      <Icon className="h-4 w-4" style={{
                    color: "hsl(135 25% 65%)"
                  }} />
                    </span>
                    <span className="tracking-tight">{link.label}</span>
                  </Button>
                </Link>;
          })}

            <div className={`mt-4 rounded-md border-[1px] border-dashed p-5 transition-all duration-700 delay-[600ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            borderColor: "hsl(135 20% 85% / 0.25)",
            fontFamily: "var(--font-mono)"
          }}>
              <div className="text-xs tracking-[0.2em] uppercase mb-2" style={{
              color: "hsl(135 25% 65%)"
            }}>
                 Event Schedule
              </div>
              <p className="text-sm leading-relaxed" style={{
              color: "hsl(120 15% 95% / 0.8)"
            }}>
                Brunch: 11:00am — 1:00pm
                <br />
                Toasts: 1:30pm — 2:30pm
              </p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marqueeLetsCollab {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}